import { render } from "./notes-modal.vue?vue&type=template&id=1e8630ae"
import script from "./notes-modal.vue?vue&type=script&lang=js"
export * from "./notes-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__